// Read an image file and return a resized JPEG data URL (keeps avatars small for storage).
export function fileToResizedDataUrl(file, max = 256, quality = 0.82) {
    return new Promise((resolve, reject) => {
        if (!file || !file.type.startsWith("image/")) {
            reject(new Error("Please select an image file."));
            return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                let { width, height } = img;
                if (width > height) {
                    if (width > max) { height = Math.round((height * max) / width); width = max; }
                } else if (height > max) {
                    width = Math.round((width * max) / height); height = max;
                }
                const canvas = document.createElement("canvas");
                canvas.width = width; canvas.height = height;
                canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                resolve(canvas.toDataURL("image/jpeg", quality));
            };
            img.onerror = () => reject(new Error("Could not read image."));
            img.src = e.target.result;
        };
        reader.onerror = () => reject(new Error("Could not read file."));
        reader.readAsDataURL(file);
    });
}
